import './whatsapp_message_content.js.coffee'

Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.WhatsappContactMessageContent extends Monitoring.Models.SocialContents.WhatsappMessageContent

  getContactName: ->
   @json.whatsappMessage.firstName + ' ' +  @json.whatsappMessage.lastName

  getAddresses: ->
    @json.whatsappMessage.addresses


  getPhones: ->

    @json.whatsappMessage.phones


  getEmails: ->

    @json.whatsappMessage.emails

  getContactUrls: ->
    @json.whatsappMessage.urls

  getBirthday: ->
    @json.whatsappMessage.birthday

  getCompanyData: ->

    @json.whatsappMessage.company


  getAvatarForView: ->
    window.image_path('user-default-img-copia' + '.png')
